
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/system/spacing",
      function () {
        return require("private-next-pages/system/spacing.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/system/spacing"])
      });
    }
  